import both from 'ramda/es/both'
import { calcSimplePoints } from '../_common/pointsCalculationHelper'

export const calculatePoints = (answer) => {
    const question = answer.question()
    const isCountPerAnswer = question.countPerAnswer()
    if (!isCountPerAnswer) return calcSimplePoints(answer)

    const answers = answer.userInput()
    if (!answers || answers.length < 1) return 0

    const expectedAnswers = answer.correctAnswers()

    const maxCorrect = expectedAnswers.length
    const points = Number(question.points())
    const pointsPerAnswer = points / maxCorrect

    /** this case must not be, since frontend should block entering more than desired */
    if (answers.length > expectedAnswers.length) {
        return 0
    }

    const results = answers.map((a) => {
        console.log('a', JSON.stringify(a))
        return expectedAnswers.some((b) => a.key == b)
    })
    const result = results.reduce((acc, curr) => {
        if (curr) acc += pointsPerAnswer
        return acc
    }, 0)

    return result
}
